import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Layout, Button } from "antd";

import logoBig from "../layout/assets/logo_big.png";
import logoSmall from "../layout/assets/logo_small.png";

import "./styles/NotFoundPage.css";

const { Content } = Layout;

class NotFoundPage extends Component {
  render() {
    return (
      <Content className="not-found-wrapper">
        <div className="not-found-container">
          <div className="not-found-container-content">
            <div className="image-container">
              <img
                srcSet={`${logoSmall} 75w, ${logoBig} 400w`}
                sizes="(max-width: 900px) 8vw, (max-width: 600px) 12vw, (max-width: 400) 20vw"
                alt="Dallas Hermanson Full Stack Developer"
                className="not-found-image"
                src={logoSmall}
              />
            </div>
            <h1>404: That page does not exist!</h1>
            <Button type="primary">
              <Link to="/">Head home</Link>
            </Button>
          </div>
        </div>
      </Content>
    );
  }
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/components/pages/NotFoundPage.js